import {
  DevHubButton,
  DevHubDynamicIcon,
  DevHubSwitch,
  DevHubGrid,
} from '@devxdiscover/devhub-ui';

/**
 * This is a component that toggles between starred and unstarred apps
 * @param props the props of the component
 * @param props.onViewChange function to change the view
 * @param props.starMode boolean that determines if the view is starred or unstarred
 */
export const StarredViewToggle = ({
  onViewChange,
  starMode,
}: {
  onViewChange: (arg0: boolean) => void;
  starMode: boolean;
}) => {
  const toggleView = () => {
    onViewChange(!starMode);
  };

  return (
    <DevHubGrid container spacing={1}>
      <DevHubGrid item>
        <DevHubButton onClick={toggleView} variant="outlined">
          <DevHubDynamicIcon iconName="StarSharp" color="gold" />
          View Starred Apps
          <DevHubSwitch checked={starMode} />
        </DevHubButton>
      </DevHubGrid>
    </DevHubGrid>
  );
};
